const flavoursCl = {
    categoriesWrapper: 'flavour-categories-list-js',
    collectionsWrapper: 'flavour-collection-list-js',
    categoriesItem: 'flavour-categories-item-js',
    categoriesItemActive: 'flavour-categories-item-active-js',
    collectionItem: 'flavour-collection-item-js',
    collectionItemHidden: 'flavour-collection-item-hidden-js',
}

const toggleCollectionList = function(e, flavourCategories, collectionsParent) {
    if (!e.target.classList.contains(flavoursCl.categoriesItem)) return;
    const clickedCategory = e.target.getAttribute('data-flavour-category');

    const allCollections = [...collectionsParent.querySelectorAll('.' + flavoursCl.collectionItem)]

    flavourCategories.forEach(cat => cat.classList.remove(flavoursCl.categoriesItemActive));
    e.target.classList.add(flavoursCl.categoriesItemActive);

    if (!clickedCategory) {
        allCollections.forEach(collection => collection.classList.remove(flavoursCl.collectionItemHidden));
        return;
    };

    const clickedCategoryLowerCase = clickedCategory.toLowerCase();
    
    allCollections.filter(collection => {
        const collectionCategories = collection.getAttribute('data-flavour-categories').split(',');
        const found = collectionCategories.find(cat => cat.toLowerCase().trim() === clickedCategoryLowerCase);

        if (!found) collection.classList.add(flavoursCl.collectionItemHidden);
        else collection.classList.remove(flavoursCl.collectionItemHidden);
    })
}

// const enableSwiper = function() {
//     return new Swiper('.' + flavoursCl.swiperContainer,{
//     slidesPerView: "auto",
//     spaceBetween: 24,

//     scrollbar: {
//         el: "." + flavoursCl.swiperScrollbar,
//         hide: false,
//       },

//     breakpoints: {
//         990: {
//             spaceBetween: 32,
//         },
//     },
    
//   });
// }

const flavoursInit = function() {
    const flavoursCategoriesWrapper = document.querySelector('.' + flavoursCl.categoriesWrapper);

    if (!flavoursCategoriesWrapper) return;

    const flavoursCollectionsWrapper = document.querySelector('.' + flavoursCl.collectionsWrapper);
    const flavourCategories = flavoursCategoriesWrapper.querySelectorAll('.' + flavoursCl.categoriesItem);

    // const flavourCategoriesSwiper = enableSwiper();

    flavoursCategoriesWrapper.addEventListener('click', e => {
        toggleCollectionList(e, flavourCategories, flavoursCollectionsWrapper);
    })
}

flavoursInit();

